'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import Link from 'next/link.js';
import { useRef, useState, useEffect } from 'react';
import { IconSearch } from '../../svg/icons/icon-search.js';
import { IconX } from '../../svg/icons/icon-x.js';
import { useMediaQuery, Breakpoints } from '../../util/use-media-query.js';

const SearchBar = ({ keyword, placeholder = 'Search...', menuItems, onChangeValue, onEnterPress, onClear, disabled, className = '', }) => {
    const isMd = useMediaQuery(Breakpoints.MD);
    const menuRef = useRef(null);
    const [showXButton, setShowXButton] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    useEffect(() => {
        if (isFocused && menuItems.length > 0) {
            setIsMenuOpen(true);
        }
        else {
            setIsMenuOpen(false);
        }
    }, [isFocused, menuItems]);
    useEffect(() => {
        const handleClick = (e) => {
            if (menuRef.current?.contains(e.target) ||
                menuRef.current?.contains(e.target)) {
                return;
            }
            setIsMenuOpen(false);
            setIsFocused(false);
        };
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    });
    return (jsxs("div", { className: `relative h-12 rounded-full ${className}`, children: [jsxs("div", { className: "flex w-full items-center justify-between overflow-hidden rounded-full border border-leland-gray-dark/30 shadow-none transition duration-150 focus-within:border-leland-gray-dark focus-within:shadow-md", onMouseEnter: () => {
                    if (keyword) {
                        setShowXButton(true);
                    }
                }, onMouseLeave: () => setShowXButton(false), children: [jsx(IconSearch, { className: "ml-4 size-5 text-leland-gray-extra-light" }), jsx("input", { className: `block w-full bg-white py-3 pl-2.5 pr-4 shadow-none outline-none outline-0 ring-0 placeholder:text-gray-400 ${disabled
                            ? 'cursor-not-allowed bg-leland-gray-hover pl-12 text-leland-gray-light'
                            : ''}`, type: "text", value: keyword, placeholder: placeholder, onChange: (e) => {
                            const value = e.target.value;
                            if (value && !showXButton) {
                                setShowXButton(true);
                            }
                            onChangeValue(value);
                        }, onKeyDown: (e) => {
                            if (e.key === 'Enter' && onEnterPress) {
                                onEnterPress();
                            }
                        }, onFocus: () => setIsFocused(true), disabled: disabled }), showXButton || !isMd ? (jsx("button", { type: "button", className: "mr-3 rounded-full bg-leland-gray-hover p-1.5", onClick: onClear, children: jsx(IconX, { className: "size-3 text-leland-gray-light" }) })) : null] }), isMenuOpen ? (jsx("ul", { ref: menuRef, className: "absolute top-14 z-10 max-h-60 min-h-14 w-full overflow-auto rounded-lg border border-leland-gray-stroke bg-white p-2 shadow-lg", children: menuItems.map((item) => (jsx("li", { children: jsx(Link, { href: item.href, children: jsx("button", { type: "button", className: "flex w-full items-center justify-start rounded-md p-3 text-left hover:bg-leland-gray-hover focus:bg-leland-gray-hover", onClick: () => {
                                onClear();
                                setIsMenuOpen(false);
                                setIsFocused(false);
                            }, children: item.name }) }) }, item.name))) })) : null] }));
};

export { SearchBar };
//# sourceMappingURL=search-bar.js.map
